export const COLS_COUNT = 13
export const COLS_HIDDEN_TAB_SM = 2 // LP Sqft, SP Sqft
export const COLS_VISIBLE_DT_LG_ONLY = 1 // Acre
export const COMPS_TABLE_ID = 'comps-table'
